import { Button, Grid, Paper, TextField, Typography, IconButton } from '@mui/material'
import React from 'react'
import Header from '../../Header';
import i18next from 'i18next';
import { Trans } from 'react-i18next';
import { useState } from 'react';
import { User } from '../../../types/User';
import { useNotify } from '../../Notify/NotifyProvider'
import request from '../../../helpers/myAxios'
import { useRef } from 'react';
import { useEffect } from 'react';
import { Gate, GateStatus } from '../../../types/Gate';
import EditIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import { getLoggedUser } from '../../../helpers/session';

const maxViewWidth = 1200;
var doit: any;

interface ManageGateViewProps {
}

function ManageGateView(props: ManageGateViewProps) {
    const notify = useNotify();
    //const confirm = useConfirm();

    const [gates, setGates] = useState<Gate[]>([]);

    const [editGate, setEditGate] = useState<Gate | null>(null);
    const [openGateEditor, setOpenGateEditor] = useState(false);

    const update = () => {

        request().get('/gate').then((res) => {
            setGates(res.data);
        }).catch((err) => {
            if (err.response && err.response.status === 404)
                setGates([]);
            else
                notify.error(i18next.t('GateEditor.msgNoGateFound'));
        });
    }

    //Force recalculate table size on first render
    useEffect(() => {

        //Implementing the setInterval method
        const interval = setInterval(() => {
            update();
        }, 1000);

        //Clearing the interval
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const handleAdd = () => {
        setEditGate(null);
        setOpenGateEditor(true);
    }

    const handleDelete = (e: React.MouseEvent<HTMLElement>, gate: Gate) => {
        /*confirm({
            description: i18next.t('GateEditor.msgConfirmDelete'),
            confirmationText: i18next.t('buttons.yes'),
            cancellationText: i18next.t('buttons.no')
        }).then(() => {
            request().delete('/gate/' + gate.id).then((res) => {
                update();
            }).catch((err) => {
                console.error(err);
            });
        })*/
    }

    const handleEdit = (e: React.MouseEvent<HTMLElement>, gate: Gate) => {

    }

    const handleGateOpen = (e: React.MouseEvent<HTMLElement>, gate: Gate) => {
        e.preventDefault();
        request().post('/gate/' + gate.id, { action: 'open', user: getLoggedUser() }).then((res) => {
            update();
        }).catch((err) => {
            console.error(err);
        });
    }

    const handleGateClose = (e: React.MouseEvent<HTMLElement>, gate: Gate) => {
        e.preventDefault();
        request().post('/gate/' + gate.id, { action: 'close', user: getLoggedUser() }).then((res) => {
            update();
        }).catch((err) => {
            console.error(err);
        });
    }

    const getDisplayStatus = (status: GateStatus | undefined) => {
        switch (status) {
            case 'open':
                return i18next.t("GateEditor.gateOpen");
            case 'close':
                return i18next.t("GateEditor.gateClose");
            case 'unknown':
                return i18next.t("GateEditor.gateUnknown");
        }
        return "";
    }

    let gateWidgets = gates.map(gate => {
        return <Grid item sm={6}>
            <Paper sx={{ width: maxViewWidth, p: 2, mb: 2 }}>
                <div>
                    <Grid container spacing={1}>
                        <Grid item sm={9}>
                            <Typography variant='h5'>{gate.name + ' ( ' + i18next.t("GateEditor.status") + ': ' + getDisplayStatus(gate.status) + ')'}</Typography>
                        </Grid>
                        <Grid item sm={1}>
                            <Button sx={{ ml: 2, mr: 2 }} variant='contained' color='primary' onClick={e => handleGateOpen(e, gate)}><Trans i18nKey='buttons.open' /></Button>
                        </Grid>
                        <Grid item sm={1}>
                            <Button sx={{ ml: 2, mr: 2 }} variant='contained' color='primary' onClick={e => handleGateClose(e, gate)}><Trans i18nKey='buttons.close' /></Button>
                        </Grid>
                        {/*<Grid item sm={1}>
                            <IconButton aria-label="delete" size="small" onClick={e => handleEdit(e, gate)}>
                                <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton aria-label="delete" size="small" onClick={e => handleDelete(e, gate)}>
                                <DeleteIcon fontSize="inherit" />
                            </IconButton>
    </Grid>*/}
                    </Grid>
                </div>
            </Paper>

        </Grid>;
    });

    return (
        <div style={{ display: 'flex', height: '100%', width: '100%', flexFlow: 'column' }}>
            <Header title={i18next.t("GateEditor.title")} >
                {/*<Button sx={{ ml: 2, mr: 2 }} variant='contained' color='primary' onClick={handleAdd}><Trans i18nKey='buttons.add' /></Button>*/}

                <IconButton aria-label="Refresh" size="small" onClick={update}>
                    <RefreshIcon fontSize="inherit" />
                </IconButton>
            </Header>
            <div style={{ paddingTop: 150, width: '100%' }}>
                <div style={{ margin: 'auto', width: maxViewWidth, height: '100%' }}>
                    {gateWidgets}
                </div>
            </div>
        </div>
    )
}

export default ManageGateView

